var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-img center-me"},[_c('van-icon',{staticClass:"default-photo-icon",attrs:{"name":"photo-o"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }